import axios from "axios";

export default axios.create({
    baseURL: "/images",
    cache: false  // disable caching, because otherwise editing images gets messy
});
